import { render } from "./FrontPageAds.vue?vue&type=template&id=4b682ded&scoped=true&ts=true"
import script from "./FrontPageAds.vue?vue&type=script&lang=ts"
export * from "./FrontPageAds.vue?vue&type=script&lang=ts"

import "./FrontPageAds.vue?vue&type=style&index=0&id=4b682ded&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b682ded"]])

export default __exports__